<template>
  <div id="userprofile-dialog" class="custom-modal">
    <div class="modal-body no-footer">
      <transition name="el-fade-in" mode="out-in">
        <el-row>
          <div class="container-inner" v-if="currentUserProfile != null">
            <div class="profile-picture-container">
              <div class="profile-picture" :style="'background-image: url(' + $imageus + currentUserProfile.image + '?width=184&height=184&mode=cover)'"></div>

              <div class="profile-name">
                <h5>{{ currentUserProfile.fullName }}</h5>
                <p v-if="(currentUserProfile.contactInfo && currentUserProfile.contactInfo.title != null && currentUserProfile.contactInfo.title != '') || (currentUserProfile.contactInfo.company != null && currentUserProfile.contactInfo.company != '')">
                  <span class="title" v-if="currentUserProfile.contactInfo.title != null && currentUserProfile.contactInfo.title != ''">{{ currentUserProfile.contactInfo.title }}</span>
                  <span v-if="currentUserProfile.contactInfo.company != null && currentUserProfile.contactInfo.company != ''"> {{ currentUserProfile.contactInfo.title != null && currentUserProfile.contactInfo.title != "" ? "@ " : "" }} {{ currentUserProfile.contactInfo.company }} </span>
                </p>
              </div>
            </div>
            <div class="profile-alert-area">
              <CustomAlert :title="currentUserProfile.showMeOnAPP ? $t('userProfile.profileActive') : $t('userProfile.profileDeactive')" :message="currentUserProfile.showMeOnAPP ? $t('userProfile.profileActiveText') : $t('userProfile.profileDeactiveText')" :icon="currentUserProfile.showMeOnAPP ? 'fas fa-eye' : 'fas fa-eye-slash'" :active="currentUserProfile.showMeOnAPP" />
              <CustomAlert :title="currentUserProfile.showMeBusy ? $t('userProfile.profileBusy') : $t('userProfile.profileAvailable')" :message="currentUserProfile.showMeBusy ? $t('userProfile.profileBusyText') : $t('userProfile.profileAvailableText')" :icon="!currentUserProfile.showMeBusy ? 'fas fa-bell' : 'fas fa-bell-slash'" :active="!currentUserProfile.showMeBusy" />
            </div>

            <div class="call-bar" v-if="currentUserProfile.id != currentUser.id">
              <el-tooltip :content="'Message'" placement="top">
                <div class="call-bar-item" @click="openMessageBlock" :class="currentUser.blockedUserIds.some(x => x == currentUserProfile.id) ? 'disabled' : ''">
                  <i class="fa fa-times" v-if="messageBlock"></i>
                  <i class="comment-profile-icon" v-else></i>
                </div>
              </el-tooltip>
              <el-tooltip :content="'Voice call'" placement="top">
                <div class="call-bar-item disabled"><i class="fas fa-phone-alt"></i></div>
              </el-tooltip>
              <el-tooltip :content="'Video call'" placement="top">
                <div class="call-bar-item disabled"><i class="fas fa-video-camera"></i></div>
              </el-tooltip>
            </div>

            <div v-if="messageBlock" class="send-messagepanel-container">
              <textarea name v-model="message" id cols="30" rows="5" @keydown.enter.exact.prevent @keyup.enter.exact="sendMessage" :placeholder="$t('write_message')"></textarea>
              <el-button @click="sendMessage" :loading="loading == 'sendMessage'" type="primary">{{ $t("send") }}</el-button>
            </div>
            <div class="about-section">
              <div class="about-section-left">
                <div class="icon-box big">
                  <i class="fas fa-user"></i>
                </div>
                <div class="icon-box" v-if="currentUserProfile.id != currentUser.id">
                  <i class="fas" :class="currentUserProfile.isFollowed ? 'fa-minus' : 'fa-plus'"></i>
                </div>
                <div class="icon-box" v-if="currentUserProfile.id != currentUser.id">
                  <i class="fas" :class="currentUser.blockedUserIds.some(x => x == currentUserProfile.id) ? 'fas fa-user-slash' : 'fas fa-user'"></i>
                </div>
                <div class="icon-box" v-if="currentUserProfile.contactInfo.email != null && currentUserProfile.contactInfo.email != undefined && currentUserProfile.contactInfo.email != ''">
                  <i class="fas fa-envelope"></i>
                </div>
                <div class="icon-box" v-if="currentUserProfile.contactInfo.phone != null && currentUserProfile.contactInfo.phone != undefined && currentUserProfile.contactInfo.phone != ''">
                  <i class="fas fa-phone-alt"></i>
                </div>
                <div class="icon-box" v-if="currentUserProfile.contactInfo.cellPhone != null && currentUserProfile.contactInfo.cellPhone != undefined && currentUserProfile.contactInfo.cellPhone != ''">
                  <i class="fas fa-mobile"></i>
                </div>
                <div class="icon-box" v-if="currentUserProfile.contactInfo.about != null && currentUserProfile.contactInfo.about != undefined && currentUserProfile.contactInfo.about != ''">
                  <i class="fas fa-info"></i>
                </div>
              </div>
              <div class="about-section-right">
                <span class="about-section-title">{{ $t("userProfile.info") }}</span>
                <div class="about-section-menu-item" v-if="currentUserProfile.id != currentUser.id">
                  <div class="about-section-menu-text">
                    {{ currentUserProfile.isFollowed ? $t("userProfile.remove_contact") : $t("userProfile.add_contact") }}
                  </div>
                  <el-switch v-model="currentUserProfile.isFollowed" @change="toggleFollow"> </el-switch>
                </div>
                <div class="about-section-menu-item" v-if="currentUserProfile.id != currentUser.id">
                  <div class="about-section-menu-text">
                    {{ currentUser.blockedUserIds.some(x => x == currentUserProfile.id) ? $t("userProfile.unblock_user") : $t("userProfile.block_user") }}
                  </div>
                  <el-switch :value="currentUser.blockedUserIds.some(x => x == currentUserProfile.id)" @change="toggleBlock"> </el-switch>
                </div>
                <!-- <div class="about-section-menu-item clickable" @click="$root.$emit('network-request', currentUserProfile.id)" v-if="currentUserProfile.id != currentUser.id && $route.params.slug != undefined && $route.name != 'home'">
                  <div class="about-section-menu-text">
                    {{ $t("send_network_req") }}
                  </div>
                </div> -->

                <a class="about-section-menu-item" :href="'mailto:' + currentUserProfile.contactInfo.email" v-if="currentUserProfile.contactInfo.email != null && currentUserProfile.contactInfo.email != undefined && currentUserProfile.contactInfo.email != ''">
                  <div class="about-section-menu-text">
                    {{ currentUserProfile.contactInfo.email }}
                  </div>
                </a>
                <a class="about-section-menu-item" :href="'tel:' + currentUserProfile.contactInfo.phone" v-if="currentUserProfile.contactInfo.phone != null && currentUserProfile.contactInfo.phone != undefined && currentUserProfile.contactInfo.phone != ''">
                  <div class="about-section-menu-text">
                    {{ currentUserProfile.contactInfo.phone }}
                  </div>
                </a>
                <a class="about-section-menu-item" :href="'tel:' + currentUserProfile.contactInfo.cellPhone" v-if="currentUserProfile.contactInfo.cellPhone != null && currentUserProfile.contactInfo.cellPhone != undefined && currentUserProfile.contactInfo.cellPhone != ''">
                  <div class="about-section-menu-text">
                    {{ currentUserProfile.contactInfo.cellPhone }}
                  </div>
                </a>
                <div class="about-section-menu-item info" v-if="currentUserProfile.contactInfo.about != null && currentUserProfile.contactInfo.about != undefined && currentUserProfile.contactInfo.about != ''">
                  <div class="about-section-menu-text">
                    {{ currentUserProfile.contactInfo.about }}
                  </div>
                </div>
              </div>
            </div>
            <div class="same-events" v-if="currentUser.id != currentUserProfile.id && currentUserProfile.sameEvents && currentUserProfile.sameEvents.length > 0">
              <div class="same-events-header">
                <div class="icon-box big">
                  <i class="fas fa-users"></i>
                </div>
                <div class="same-events-title">{{ $t("userProfile.sameEvents") }}</div>
              </div>
              <div class="same-events-item" v-for="item in currentUserProfile.sameEvents" :key="item.id">
                <div class="icon-area">
                  <div class="icon-box">
                    <i class="fas fa-calendar"></i>
                  </div>
                </div>
                <div class="same-events-event-info">
                  <div class="same-events-event-title">{{ item.title }}</div>
                  <div class="same-events-event-date">
                    {{
                      moment(item.startDate)
                        .utc()
                        .format("DD MMMM, YYYY")
                    }}
                  </div>
                </div>
                <el-button type="primary" :size="innerWidth > 768 ? 'medium' : 'mini'" :style="innerWidth > 768 ? 'height:40px;' : 'height:auto;'" v-if="item.isB2BNetworkingEnabled" round @click="createAppointment(item.id)"> {{ $t("userProfile.makeAppointment") }}</el-button>
              </div>
            </div>
            <!-- Job List Start -->
            <div class="other-section" v-if="currentUserProfile.jobs.length">
              <div class="other-section-header">
                <div class="icon-box">
                  <i class="fas fa-briefcase"></i>
                </div>
                <span class="other-section-title">{{ $t("settings.job_title") }}</span>
              </div>
              <div class="other-section-body">
                <div class="other-section-body-item" v-for="item in currentUserProfile.jobs" :key="item.id">
                  <div class="other-section-body-item-title">{{ item.firmName }}</div>
                  <div class="other-section-body-item-head">{{ item.position }}</div>
                  <div class="other-section-body-item-subhead">{{ moment(item.dateStart).format("D MMMM YYYY") }} - {{ item.dateEnd == null || item.dateEnd == "" ? $t("settings.no_end") : moment(item.dateEnd).format("D MMMM YYYY") }}</div>
                </div>
              </div>
            </div>
            <!-- <div class="section-title" v-if="currentUserProfile.jobs.length">
              <span>{{ $t("settings.job_title") }}</span>
            </div>

            <div v-for="item in currentUserProfile.jobs" :key="item.id" class="custom-card">
              <div class="custom-card-header">
                <div class="md-title" style="margin: 0; font-size: 18px;">{{ item.firmName }}</div>
                <div class="md-subhead bold">{{ item.position }}</div>
                <div class="md-subhead">{{ moment(item.dateStart).format("D MMMM YYYY") }} - {{ item.dateEnd == null || item.dateEnd == "" ? $t("settings.no_end") : moment(item.dateEnd).format("D MMMM YYYY") }}</div>
              </div>
            </div> -->

            <!-- Job List End -->

            <!-- School List Start -->
            <div class="other-section" v-if="currentUserProfile.schools.length">
              <div class="other-section-header">
                <div class="icon-box">
                  <i class="fas fas fa-graduation-cap"></i>
                </div>
                <span class="other-section-title">{{ $t("settings.school_title") }}</span>
              </div>
              <div class="other-section-body">
                <div class="other-section-body-item" v-for="item in currentUserProfile.schools" :key="item.id">
                  <div class="other-section-body-item-title">{{ item.title }}</div>
                  <div class="other-section-body-item-head">{{ item.department }}</div>
                  <div class="other-section-body-item-subhead">{{ moment(item.dateStart).format("D MMMM YYYY") }} - {{ item.dateEnd == null || item.dateEnd == "" ? $t("settings.no_end") : moment(item.dateEnd).format("D MMMM YYYY") }}</div>
                </div>
              </div>
            </div>
            <!-- <div class="section-title" v-if="currentUserProfile.schools.length">
              <span>{{ $t("settings.school_title") }}</span>
            </div>

            <div v-for="item in currentUserProfile.schools" :key="item.id" class="custom-card">
              <div class="custom-card-header">
                <div class="md-title" style="margin: 0; font-size: 18px;">{{ item.title }}</div>
                <div class="md-subhead bold">{{ item.department }}</div>
                <div class="md-subhead">{{ moment(item.dateStart).format("D MMMM YYYY") }} - {{ item.dateEnd == null || item.dateEnd == "" ? $t("settings.no_end") : moment(item.dateEnd).format("D MMMM YYYY") }}</div>
              </div>
            </div> -->

            <!-- School List End -->

            <!-- Language List Start -->
            <div class="other-section" v-if="currentUserProfile.languages.length">
              <div class="other-section-header">
                <div class="icon-box">
                  <i class="fas fa-globe-americas"></i>
                </div>
                <span class="other-section-title">{{ $t("userProfile.language") }}</span>
              </div>
              <div class="other-section-body">
                <div class="other-section-body-item" v-for="item in currentUserProfile.languages" :key="item.id">
                  <div class="other-section-body-item-title">{{ item.language.title }}</div>
                  <div class="other-section-body-item-head">{{ $t("userProfile.speaking") }}{{ getEnumsDisplay("UserLanguageLevel", item.reading) }}</div>
                  <div class="other-section-body-item-subhead">{{ $t("userProfile.writeRead") }}{{ getEnumsDisplay("UserLanguageLevel", item.writing) + " / " + getEnumsDisplay("UserLanguageLevel", item.reading) }}</div>
                </div>
              </div>
            </div>
            <!-- Language List End -->

            <!-- Interest List Start -->
            <div class="other-section" v-if="currentUserProfile.interests.length">
              <div class="other-section-header">
                <div class="icon-box">
                  <i class="fas fa-star"></i>
                </div>
                <span class="other-section-title">{{ $t("settings.interest_title") }}</span>
              </div>
              <div class="other-section-body">
                <div class="interest-container">
                  <div class="interest-item" v-for="(i, index) in currentUserProfile.interests" :key="i + '-interest-' + index">{{ i }}</div>
                </div>
              </div>
            </div>
            <!-- Interest List End -->
          </div>
        </el-row>
      </transition>

      <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="error.hasError" md-persistent>
        <i class="fa fa-exclamation-triangle"></i><span>{{ error.message }}</span>
      </md-snackbar>
    </div>
    <!-- <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">Close</el-button>
      </div>
      <div class="right-buttons">
      </div>
    </div> -->
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import axios from "axios";

export default {
  name: "UserProfileDialog",

  data() {
    return {
      moment,
      messageBlock: false,
      message: null,
      error: {
        message: null,
        hasError: false
      },
      loading: false,
      timeout: null
    };
  },
  computed: {
    innerWidth() {
      return window.innerWidth;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    innerWidth() {
      return window.innerWidth;
    },
    currentUserProfile() {
      return this.$store.state.currentUserProfile;
    },
    currentUser() {
      return this.$store.state.user;
    }
  },

  methods: {
    openMessageBlock() {
      if (!this.currentUser.blockedUserIds.some(x => x == this.currentUserProfile.id)) {
        this.messageBlock = !this.messageBlock;
      }
    },
    createAppointment(eventId) {
      var participant = JSON.parse(JSON.stringify(this.currentUserProfile));
      participant.userID = participant.id;
      this.$root.$emit("makeAppointmentDialog", participant, eventId, null, 0);
    },
    async toggleBlock() {
      var res = await axios.post("account/toggleblockquery", {
        id: this.currentUserProfile.id
      });
      if (res.data.hasError) {
        this.$message.error(res.data.message);
      } else {
        var fIndex = this.currentUser.blockedUserIds.findIndex(x => this.currentUserProfile.id);
        if (res.data.data.isBlocked) {
          if (fIndex == -1) {
            this.currentUser.blockedUserIds.push(this.currentUserProfile.id);
          }
        } else {
          if (fIndex != -1) {
            this.currentUser.blockedUserIds.splice(fIndex, 1);
          }
        }
      }
    },
    async toggleFollow(value) {
      var res = await axios.post("profile/changefollow", {
        userID: this.currentUserProfile.id,
        follow: value
      });
      if (res.data.hasError) {
        this.$message.error(res.data.message);
      } else {
        this.currentUserProfile.isFollowed = value;
        this.$message.success(res.data.message);
      }
    },

    async sendMessage() {
      this.loading = "sendMessage";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var response = await axios.post("chat/sendmessage", {
          userID: this.currentUserProfile.id,
          messageText: this.message
        });
        if (response.data.hasError) {
          this.$message.error(response.data.message);
        } else {
          this.$message.success(this.$t("message_sent"));
        }
        this.message = null;
        this.loading = false;
        this.messageBlock = false;
      }, 500);
    }
  }
};
</script>

<style lang="less">
#userprofile-dialog {
  width: 100%;

  .call-bar {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
    border-radius: 16px;
    padding: 6px 32px;

    .call-bar-item {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &.disabled {
        opacity: 0.5;
        filter: grayscale(100%);
        cursor: not-allowed !important;
        cursor: no-drop !important;
      }

      i {
        color: #268ea6;
        &.comment-profile-icon {
          background-color: #268ea6;
        }
        font-size: 28px;
        padding: 14px;
      }
    }
  }

  .info-card {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    background-color: #fbfbfb;
    padding: 10px 12px;
    border: 0.5px solid #d6d9d9;
    border-radius: 8px;

    i {
      width: 50px;
      height: 50px;
      background: white;
      border: 5px solid #d6d9d9;
      border-radius: 50%;
      line-height: 0.7;
      font-size: 26px;
      color: #268ea6;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    span {
      padding-left: 10px;
      max-width: calc(~"100% - 70px");
      margin: 0px;
      color: #505763;
      font-size: 13px;
    }
  }

  .container-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 24px;
    padding: 0px 4px;
    margin: 0px;

    .profile-picture-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 24px;

      .profile-picture {
        width: 184px;
        height: 184px;
        background-size: cover;
        border-radius: 50%;
        border: 6px solid #e8ebef;
        cursor: pointer;
      }
      .profile-name {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
        gap: 4px;

        h5 {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #292f3b;
          margin: 0;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          margin: 0;
          max-width: 500px;
          color: #505763;
          .title {
            font-weight: 500;
          }
        }
      }
    }
    .profile-alert-area {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
    }

    .account-confirmation-section {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      background: aliceblue;
      padding: 4px 12px;
      margin-top: 6px;
      border-radius: 8px;
    }

    .section-title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 16px 6px 10px 6px;

      span {
        color: #505763;
        font-weight: 500;
        font-size: 14px;
      }
    }

    .section-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      background-color: #f6f6f6;
      border-radius: 8px;
      padding: 14px;

      .custom-switch-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-height: 52px;
        gap: 10px;

        &:hover {
          text-decoration: none;
        }

        &.clickable {
          cursor: pointer;
        }

        &.disabled {
          opacity: 0.5;
          filter: grayscale(100%);
          cursor: not-allowed !important;
          cursor: no-drop !important;
        }

        .row-left {
          flex-direction: row;
          align-items: center;
          display: flex;
          justify-content: flex-start;
          i {
            width: 30px;
            height: 30px;
            background: #268ea6;
            border-radius: 50%;
            line-height: 0.7;
            padding: 11px 8px;
            font-size: 14px;
            color: white;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          span {
            color: #505763;
            font-weight: 500;
            font-size: 14px;
            margin-left: 6px;
          }
        }

        .row-right {
          flex-shrink: 0;
          i {
            color: #268ea6;
          }
        }
      }
    }

    .custom-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin-top: 12px;

      label {
        color: #505763;
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 6px;
      }

      input {
        width: 100%;
        border: 0;
        height: 40px;
        border-radius: 8px;
        outline: none;
        padding: 8px 12px;
        box-sizing: border-box;
        border: 0.5px solid #d6d9d9;
        background: #fbfbfb;
        height: 48px;
      }

      textarea {
        width: 100% !important;
        border: 0;
        height: 100px !important;
        border-radius: 8px;
        outline: none;
        padding: 8px 12px;
        box-sizing: border-box;
        border: 0.5px solid #d6d9d9;
        background: #fbfbfb;
        font-family: "Roboto", sans-serif;
        font-size: 13px;
      }

      span {
        font-size: 13px;
        color: #f22f2f;
        margin-top: 3px;
      }

      &.phone {
        .vue-phone-number-input {
          width: 100%;
        }

        .country-selector__country-flag {
          top: 18px;
        }

        .country-selector__input {
          border-radius: 8px 0px 0px 8px !important;
          border: 0.5px solid #d6d9d9 !important;
          box-shadow: none !important;
          padding-left: 40px;
        }

        .input-tel__input {
          border-radius: 0px 8px 8px 0px !important;
          border: 0.5px solid #d6d9d9 !important;
          box-shadow: none !important;
        }

        .country-selector__label {
          display: none;
        }

        .input-tel__label {
          display: none;
        }
      }
    }

    .form-confirm {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 20px;
      width: 100%;

      button {
        border: unset;
        background: #03658c;
        color: white;
        width: 200px;
        border-radius: 8px;
        font-size: 16px;
        padding: 14px;
        font-weight: 500;
        cursor: pointer;

        &.btn-xl {
          width: 300px;
        }

        &.disbled {
          cursor: no-drop;
          background-color: #8c929c;
        }

        &.close {
          background-color: #8c929c;
        }
      }
    }

    .send-messagepanel-container {
      background-color: #f6f6f6 !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 15px 25px;
      margin-bottom: 16px;
      border-radius: 8px;
      position: relative;

      textarea {
        display: block;
        width: 100% !important;
        min-height: inherit;
        max-height: 286px;
        border: none;
        font-family: "Roboto", sans-serif;
        font-size: 14px;
        background: none;

        &:focus {
          outline: none !important;
          border: none !important;
        }
      }

      button {
        width: 100%;
        margin-top: 6px;
        padding: 12px 0px;
        border-radius: 8px;
        border: none;
        background-color: #03658c;
        color: white;
        font-weight: 600;
        font-family: "Roboto", sans-serif;
        cursor: pointer;
      }
    }
    .same-events {
      display: flex;
      flex-direction: column;
      padding: 10px 10px 16px;
      gap: 16px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 16px;
      position: relative;
      &::after {
        position: absolute;
        content: "";
        width: 2px;
        height: calc(~"100% - 26px");
        left: 31px;
        top: 10px;
        bottom: 0;
        z-index: 0;
        background-color: #f1f3f6;
      }
      .icon-box {
        z-index: 1;
        &.big {
          width: 44px;
          height: 44px;
          background: #f1f3f6;

          & > i {
            font-size: 24px;
            color: #268ea6;
          }
        }
        width: 28px;
        height: 28px;
        border: 2px solid #f1f3f6;
        background: #268ea6;
        border-radius: 48px;
        display: flex;
        align-items: center;
        justify-content: center;

        & > i {
          font-size: 14px;
          color: white;
        }
      }
      .same-events-header {
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        gap: 8px;
        align-items: center;
        height: max-content;
        .same-events-title {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
        }
      }
      .same-events-item {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        .icon-area {
          width: 44px;
          display: flex;
          flex-shrink: 0;

          height: 44px;
          align-items: center;
          justify-content: center;
        }
        .same-events-event-info {
          .same-events-event-title {
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            color: #292f3b;
            word-break: break-word;
          }
          .same-events-event-date {
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
          }
        }
        .el-button {
          margin-left: auto;
          height: 40px;
          font-weight: bold;
        }
      }
    }
    .other-section {
      display: flex;
      flex-direction: column;
      padding: 10px 10px 16px;
      gap: 16px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 16px;
      .other-section-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        & > .icon-box {
          width: 48px;
          height: 48px;
          background: #f1f3f6;
          border-radius: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          i {
            color: #268ea6;
          }
        }
        .other-section-title {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #292f3b;
        }
      }
      .other-section-body  {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .interest-container {
          display: flex;
          flex-direction: row;
          gap: 10px;
          flex-wrap: wrap;
          .interest-item {
            display: flex;
            align-items: center;
            padding: 6px 10px;
            background: #268ea6;
            border-radius: 32px;
            color: #ffffff;
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .other-section-body-item {
          display: flex;
          background: #f1f3f6;
          border-radius: 12px;
          flex-direction: column;
          padding: 4px 10px;
          color: #505763;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          .other-section-body-item-title {
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            color: #292f3b;
          }
        }
      }
    }
    .about-section {
      display: flex;
      flex-direction: row;
      padding: 10px 10px 16px;
      gap: 16px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 16px;
      .about-section-left {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        gap: 16px;
        align-items: center;
        height: max-content;
        position: relative;
        &::after {
          position: absolute;
          content: "";
          width: 2px;
          height: auto;
          left: 21px;
          top: 0;
          bottom: 0;
          z-index: 0;
          background-color: #f1f3f6;
        }
        & > .icon-box {
          z-index: 1;
          &.big {
            width: 44px;
            height: 44px;
            background: #f1f3f6;

            & > i {
              font-size: 24px;
              color: #268ea6;
            }
          }
          width: 28px;
          height: 28px;
          border: 2px solid #f1f3f6;
          background: #268ea6;
          border-radius: 48px;
          display: flex;
          align-items: center;
          justify-content: center;

          & > i {
            font-size: 14px;
            color: white;
          }
        }
      }
      .about-section-right {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 16px;
        .about-section-title {
          height: 44px;
          display: flex;
          align-items: center;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #292f3b;
        }
        a.about-section-menu-item {
          text-decoration: none;
          cursor: pointer;
        }
        .about-section-menu-item {
          &.clickable {
            cursor: pointer;
          }
          &.info {
            height: auto;
          }
          height: 28px;
          display: flex;
          align-items: center;
          text-decoration: none;
          width: 100%;
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          .el-switch {
            margin-left: auto;
          }
          .about-section-menu-text {
            color: #505763;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            word-break: break-word;
          }
        }
      }
      .about-section-body {
        z-index: 1;
        display: flex;
        flex-direction: column;
        a.about-section-menu-item {
          text-decoration: none;
          cursor: pointer;
        }
        .about-section-menu-item {
          text-decoration: none;
          width: 100%;
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          .icon-area {
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            &.info {
              height: unset;
              align-items: flex-start;
              flex-grow: 1;
            }
            flex-shrink: 0;
            & > .icon-box {
              width: 28px;
              height: 28px;
              background: #268ea6;
              border: 2px solid #f1f3f6;
              border-radius: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                color: white;
                font-size: 14px;
              }
            }
          }
          .el-switch {
            margin-left: auto;
          }
          .about-section-menu-text {
            color: #505763;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            word-break: break-word;
          }
        }
      }
    }

    .custom-card {
      background-color: #f6f6f6 !important;
      margin-bottom: 8px;
      border-radius: 8px;
      width: 100%;

      .md-card-header {
        padding: 0px;
        align-items: center;
      }

      .custom-card-header {
        padding: 8px 12px !important;

        .md-title {
          font-weight: 500;
          color: #292f3b;
        }

        .md-subhead {
          color: #505763;
          &.bold {
            font-weight: 500;
          }
        }
      }
    }

    .chips-container {
      display: inline-grid;
      grid-template-columns: 1fr 1fr;
      position: relative;
      flex: 1 0 100%;
      width: 100%;
      white-space: break-spaces;
      word-break: break-word;
      max-width: 100%;
      margin-bottom: 12px;
      height: auto;
    }

    .md-chip {
      margin: 4px;
      white-space: break-spaces;
      line-height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      word-break: break-word;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserProfileDialog.vue